import { CalendarEventAction, CalendarEventActionPurposeEnum } from 'generated/graphql';

export const getTaskLabel = (actionPurpose: CalendarEventActionPurposeEnum): string => {
  switch (actionPurpose) {
    case CalendarEventActionPurposeEnum.DoubleConfirm:
      return 'Double-confirm';
    case CalendarEventActionPurposeEnum.LogAttendance:
      return 'Attendance';
    case CalendarEventActionPurposeEnum.Recruit:
      return 'Turnout';

  }
  return actionPurpose;
};

export const getTaskIcon = (actionPurpose: CalendarEventActionPurposeEnum): string => {
  switch (actionPurpose) {
    case CalendarEventActionPurposeEnum.Recruit:
      return `fa-circle-check`;
    case CalendarEventActionPurposeEnum.Confirm:
      return `fa-check`;
    case CalendarEventActionPurposeEnum.DoubleConfirm:
      return `fa-check-double`;
    case CalendarEventActionPurposeEnum.LogAttendance:
      return `fa-user`;
  }
  return ``;
};

export const getTaskDefaultDaysBefore = (actionPurpose: CalendarEventActionPurposeEnum): number => {
  switch (actionPurpose) {
    case CalendarEventActionPurposeEnum.Confirm:
      return 5;
    case CalendarEventActionPurposeEnum.DoubleConfirm:
      return 2;
    case CalendarEventActionPurposeEnum.LogAttendance:
      return 0;
  }
  return null;
};

export const sortTasks = (tasks: any[]): any[] => {
  const order = [
    CalendarEventActionPurposeEnum.Recruit,
    CalendarEventActionPurposeEnum.Confirm,
    CalendarEventActionPurposeEnum.DoubleConfirm,
    CalendarEventActionPurposeEnum.LogAttendance,
  ];

  return [...tasks].sort((a, b) => order.indexOf(a.actionPurpose) - order.indexOf(b.actionPurpose));
};
